import AssigneesContainer from "./AssigneesContainer";

export default AssigneesContainer;
